const BASE_URL = 'https://' + getCurrentEnvironment() + '.doctor.com';

export function getCurrentEnvironment(): string {
  const host = window.location.host;
  let environment = 'providers';
  switch (host) {
    case 'qa-widget.doctor.com':
      environment = 'qa-providers';
      break;
    case 'qa1-widget.doctor.com':
      environment = 'qa1-providers';
      break;
    case 'qa2-widget.doctor.com':
      environment = 'qa2-providers';
      break;
    case 'qa3-widget.doctor.com':
      environment = 'qa3-providers';
      break;
    case 'p-widget.doctor.com':
      environment = 'p-providers';
      break;
    case 'staging-widget.doctor.com':
      environment = 'staging-providers';
      break;
    case 'uat-widget.doctor.com':
      environment = 'uat-providers';
      break;
    case 'uat2-widget.doctor.com':
      environment = 'uat2-providers';
      break;
    case 'pat-widget.doctor.com':
      environment = 'pat-providers';
      break;
    case 'release-widget.doctor.com':
      environment = 'release-providers';
      break;
    case 'beta-widget.doctor.com':
      environment = 'beta-providers';
      break;
    case 'skunkworks-widget.doctor.com':
      environment = 'skunkworks-providers';
      break;
    case 'bs-local.com:3000': // bs-local: to enable browser stack testing
    case 'app-local.doctor.com:3000':
    case 'localhost:3000':
      environment = 'qa1-providers';
      break;
    default:
      break;
  }
  return environment;
}

export const providerSuggestEndpoint = `${BASE_URL}/api/provider/search`;
export const stateSuggestEndpoint = `${BASE_URL}/api/data/getStates`;
export const signUp = `${BASE_URL}/api/account/signup`;
